/**
 * handleItemReceived.js
 *
 * Copyright (c) apploft. GmbH
 */

import {Path, APIDefinition} from 'apploft-cloud-client';
import {presentingEditingForm} from '../ContentStateSymbol';

export default function handleItemReceived({item, section, api}) {
  const paths = APIDefinition.pathsMatching(section, api);
  const widgetProps = Path.findPostProps(paths);

  return {
    state: presentingEditingForm,
    data: {item, widgetProps, section, api},
  };
}
